{
  "enum": {
    "IxfHoursV1CalculatedType": {
      "GOOD_FRIDAY": "Good Friday",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfHoursV1DayOfWeek": {
      "FRIDAY": "Friday",
      "MONDAY": "Monday",
      "SATURDAY": "Saturday",
      "SUNDAY": "Sunday",
      "THURSDAY": "Thursday",
      "TUESDAY": "Tuesday",
      "UNSPECIFIED": "Unspecified",
      "WEDNESDAY": "Wednesday"
    },
    "IxfHoursV1ExceptionObservance": {
      "CLOSEST_WEEKDAY": "Closest Weekday",
      "EXPLICIT": "Explicit",
      "SUNDAY_TO_MONDAY": "Sunday to Monday",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfHoursV1ExceptionStatus": {
      "ACTIVE": "Active",
      "ARCHIVED": "Archived",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfHoursV1ExceptionSummaryName": {
      "ExceptionSummary": "Exception Summary",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfHoursV1MoneyMarketScheduleStatus": {
      "ACTIVE": "Active",
      "PENDING": "Pending",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfHoursV1MoneyMarketScheduleSummaryName": {
      "MoneyMarketScheduleSummary": "Money Market Schedule Summary",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfHoursV1MoneyMarketScheduleVersionStatus": {
      "APPROVED": "Approved",
      "PENDING": "Pending",
      "REJECTED": "Rejected",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfHoursV1Region": {
      "UNSPECIFIED": "Unspecified",
      "US": "United States"
    },
    "IxfHoursV1ScheduleExposure": {
      "EXTERNAL": "External",
      "INTERNAL": "Internal",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfHoursV1TradingScheduleStatus": {
      "ACTIVE": "Active",
      "PENDING": "Pending",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfHoursV1TradingScheduleSummaryName": {
      "TradingScheduleSummary": "Trading Schedule Summary",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfHoursV1TradingScheduleVersionStatus": {
      "APPROVED": "Approved",
      "PENDING": "Pending",
      "REJECTED": "Rejected",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfHoursV1TransfersScheduleStatus": {
      "ACTIVE": "Active",
      "PENDING": "Pending",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfHoursV1TransfersScheduleSummaryName": {
      "TransfersScheduleSummary": "Transfers Schedule Summary",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfHoursV1TransfersScheduleVersionStatus": {
      "APPROVED": "Approved",
      "PENDING": "Pending",
      "REJECTED": "Rejected",
      "UNSPECIFIED": "Unspecified"
    },
    "IxfHoursV1WeekOfMonth": {
      "FIRST": "First",
      "FOURTH": "Fourth",
      "LAST": "Last",
      "SECOND": "Second",
      "THIRD": "Third",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "filterEnum": {
    "IxfHoursV1ExceptionQueryServiceExceptionListFilterableFields": {
      "data": {
        "nextObservedDate": "Next Observed Date"
      },
      "exceptionId": "Exception",
      "region": "Region",
      "status": "Status"
    },
    "IxfHoursV1MoneyMarketScheduleQueryServiceMoneyMarketScheduleListFilterableFields": {
      "exposure": "Exposure",
      "status": "Status"
    },
    "IxfHoursV1MoneyMarketScheduleVersionQueryServiceMoneyMarketScheduleVersionListFilterableFields": {
      "exposure": "Exposure",
      "moneyMarketScheduleVersionId": "Money Market Schedule Version ID",
      "region": "Region",
      "status": "Status"
    },
    "IxfHoursV1TradingScheduleQueryServiceTradingScheduleListFilterableFields": {
      "exposure": "Exposure",
      "status": "Status"
    },
    "IxfHoursV1TradingScheduleVersionQueryServiceTradingScheduleVersionListFilterableFields": {
      "exposure": "Exposure",
      "region": "Region",
      "status": "Status",
      "tradingScheduleVersionId": "Trading Schedule Version ID"
    },
    "IxfHoursV1TransfersScheduleQueryServiceTransfersScheduleListFilterableFields": {
      "exposure": "Exposure",
      "status": "Status"
    },
    "IxfHoursV1TransfersScheduleVersionQueryServiceTransfersScheduleVersionListFilterableFields": {
      "exposure": "Exposure",
      "region": "Region",
      "status": "Status",
      "transfersScheduleVersionId": "Transfers Schedule Version ID"
    }
  },
  "oneOf": {
    "IxfHoursV1ExceptionEventType": {
      "archived": "Archived",
      "calculated": "Calculated",
      "created": "Created",
      "iterated": "Iterated",
      "updated": "Updated"
    },
    "IxfHoursV1ExceptionType": {
      "calculated": "Calculated",
      "fixed": "Fixed",
      "floating": "Floating"
    },
    "IxfHoursV1Hours": {
      "closed": "Closed",
      "openDayTime": "Open Day Time",
      "openTime": "Open Time"
    },
    "IxfHoursV1HoursException": {
      "closed": "Closed",
      "openTime": "Open Time"
    },
    "IxfHoursV1MoneyMarketDay": {
      "closed": "Closed",
      "open": "Open"
    },
    "IxfHoursV1MoneyMarketDayException": {
      "closed": "Closed",
      "open": "Open"
    },
    "IxfHoursV1MoneyMarketScheduleEventType": {
      "created": "Created",
      "updateRequested": "Update Requested",
      "versionApproved": "Version Approved",
      "versionRejected": "Version Rejected"
    },
    "IxfHoursV1MoneyMarketScheduleVersionEventType": {
      "approved": "Approved",
      "created": "Created",
      "rejected": "Rejected"
    },
    "IxfHoursV1OperatingHours": {
      "closed": "Closed",
      "open": "Open"
    },
    "IxfHoursV1TradingDay": {
      "closed": "Closed",
      "open": "Open"
    },
    "IxfHoursV1TradingDayException": {
      "closed": "Closed",
      "open": "Open"
    },
    "IxfHoursV1TradingScheduleEventType": {
      "created": "Created",
      "updateRequested": "Update Requested",
      "versionApproved": "Version Approved",
      "versionRejected": "Version Rejected"
    },
    "IxfHoursV1TradingScheduleVersionEventType": {
      "approved": "Approved",
      "created": "Created",
      "rejected": "Rejected"
    },
    "IxfHoursV1TransferDay": {
      "closed": "Closed",
      "open": "Open"
    },
    "IxfHoursV1TransferDayException": {
      "closed": "Closed",
      "open": "Open"
    },
    "IxfHoursV1TransfersScheduleEventType": {
      "created": "Created",
      "updateRequested": "Update Requested",
      "versionApproved": "Version Approved",
      "versionRejected": "Version Rejected"
    },
    "IxfHoursV1TransfersScheduleVersionEventType": {
      "approved": "Approved",
      "created": "Created",
      "rejected": "Rejected"
    }
  },
  "sortEnum": {
    "IxfHoursV1ExceptionQueryServiceExceptionListSortableFields": {
      "data": {
        "nextObservedDate": "Next Observed Date"
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxfHoursV1MoneyMarketScheduleQueryServiceMoneyMarketScheduleListSortableFields": {
      "metadata": {
        "createdAt": "Metadata Created At",
        "updatedAt": "Metadata Updated At"
      }
    },
    "IxfHoursV1MoneyMarketScheduleVersionQueryServiceMoneyMarketScheduleVersionListSortableFields": {
      "metadata": {
        "createdAt": "Metadata Created At",
        "updatedAt": "Metadata Updated At"
      }
    },
    "IxfHoursV1TradingScheduleQueryServiceTradingScheduleListSortableFields": {
      "metadata": {
        "createdAt": "Metadata Created At",
        "updatedAt": "Metadata Updated At"
      }
    },
    "IxfHoursV1TradingScheduleVersionQueryServiceTradingScheduleVersionListSortableFields": {
      "metadata": {
        "createdAt": "Metadata Created At",
        "updatedAt": "Metadata Updated At"
      }
    },
    "IxfHoursV1TransfersScheduleQueryServiceTransfersScheduleListSortableFields": {
      "metadata": {
        "createdAt": "Metadata Created At",
        "updatedAt": "Metadata Updated At"
      }
    },
    "IxfHoursV1TransfersScheduleVersionQueryServiceTransfersScheduleVersionListSortableFields": {
      "metadata": {
        "createdAt": "Metadata Created At",
        "updatedAt": "Metadata Updated At"
      }
    }
  }
}